/**
 * Decide whether to defer fetching a video's bytes.
 *
 * Deferring keeps a grid of videos from downloading every file on render: a cell
 * that renders the lightweight "play pill" only needs the bytes once the user
 * opens the player.
 *
 * Contexts that show a frame immediately load eagerly instead: the object viewer,
 * the peek-drawer thumbnail, and cells with the `showThumbnails` flag (e.g. eval
 * tables). So a list / table cell shows the pill only when no frame-showing
 * signal applies — otherwise it renders (and eagerly loads) a thumbnail. Once the
 * user has interacted (opened the player), we always load.
 */
export const shouldDeferVideoContentLoad = ({
  mode,
  isPeeking,
  showThumbnails,
  containerHeight,
  hasInteracted,
}: {
  mode?: string;
  isPeeking?: boolean;
  showThumbnails?: boolean;
  containerHeight: number;
  hasInteracted: boolean;
}): boolean => {
  if (hasInteracted) {
    return false;
  }
  // Peek-drawer and eval-table thumbnails render a frame immediately, so load
  // the bytes eagerly for them.
  if (isPeeking || showThumbnails) {
    return false;
  }
  const isListPill = mode !== 'object_viewer' || containerHeight < 50;
  return isListPill;
};
